import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { HealthHoldArgs } from '../api/healthHold.api';

import { fetchHealthHold } from '../api/healthHold.api';

export const healthHoldQueryKeys = createQueryKeys('healthHold', {
  fetchHealthHold: (args: HealthHoldArgs) => ({
    queryFn: () => fetchHealthHold(args),
    queryKey: [args.organizationId, args.clientId],
  }),
});
